import React from "react";
import styled from "styled-components";
import { Layout } from "../components/layout/Layout";

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: var(--spacing-4);
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: var(--spacing-6);
  color: var(--color-text-primary);
`;

const Section = styled.section`
  margin-bottom: var(--spacing-6);
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  color: var(--color-text-primary);
  margin-bottom: var(--spacing-3);
`;

const Content = styled.div`
  color: var(--color-text-secondary);
  line-height: 1.6;

  p {
    margin-bottom: var(--spacing-3);
  }

  ul {
    margin-bottom: var(--spacing-3);
    padding-left: var(--spacing-4);
  }

  li {
    margin-bottom: var(--spacing-2);
  }
`;

const PrivacyPolicy = () => {
  return (
    <Layout>
      <Container>
        <Title>Politique de Confidentialité</Title>

        <Section>
          <SectionTitle>1. Collecte des Données</SectionTitle>
          <Content>
            <p>Nous collectons les données suivantes :</p>
            <ul>
              <li>Informations de compte (email, nom d'utilisateur)</li>
              <li>Préférences de visionnage</li>
              <li>Historique de navigation sur le site</li>
              <li>Données techniques (IP, type de navigateur)</li>
            </ul>
          </Content>
        </Section>

        <Section>
          <SectionTitle>2. Utilisation des Données</SectionTitle>
          <Content>
            <p>Vos données sont utilisées pour :</p>
            <ul>
              <li>Personnaliser votre expérience utilisateur</li>
              <li>Améliorer nos services</li>
              <li>Communiquer avec vous</li>
              <li>Assurer la sécurité du site</li>
            </ul>
          </Content>
        </Section>

        <Section>
          <SectionTitle>3. Protection des Données</SectionTitle>
          <Content>
            <p>
              Nous mettons en œuvre des mesures de sécurité appropriées pour
              protéger vos données contre tout accès non autorisé, modification,
              divulgation ou destruction.
            </p>
          </Content>
        </Section>

        <Section>
          <SectionTitle>4. Vos Droits (RGPD)</SectionTitle>
          <Content>
            <p>Vous disposez des droits suivants :</p>
            <ul>
              <li>Droit d'accès à vos données</li>
              <li>Droit de rectification</li>
              <li>Droit à l'effacement</li>
              <li>Droit à la portabilité</li>
              <li>Droit d'opposition</li>
            </ul>
          </Content>
        </Section>

        <Section>
          <SectionTitle>5. Contact</SectionTitle>
          <Content>
            <p>
              Pour toute question concernant vos données personnelles :<br />
              Email : ytbrelaxmusic@gmail.com
            </p>
          </Content>
        </Section>
      </Container>
    </Layout>
  );
};

export default PrivacyPolicy;
